import localForage from 'localforage';
import { Service } from '~/types/models';
import usePurser from './use-purser';
import { useEffect } from 'react';

export const SessionCountsForQuickStartGuidePage = [2, 5, 10];

export default function useQuickStartGuideSessionRecorder(service: Service) {
  const purser = usePurser();

  useEffect(() => {
    const sessionCount = purser.data?.count ?? 0;

    if (
      purser.data &&
      SessionCountsForQuickStartGuidePage.includes(sessionCount)
    ) {
      localForage.setItem(
        `${service}-quick-start-guide-viewed-on-session-${sessionCount}`,
        String(true)
      );
    }
  }, [purser, service]);
}
